import _ from 'lodash';
import { useTranslation } from 'react-i18next';

import * as graphql from 'generated/graphql';
import useLocalize from 'packages/kakapo-ui-application/hooks/useLocalize';

import EmployeesFilter from '../EmployeesFilter';

export default function EmployeesCycleFilter() {
	const { t } = useTranslation();
	const { localize } = useLocalize();

	const query = graphql.useCycleTemplatesQuery({
		variables: {
			isArchived: false,
			first: 1000,
		},
	});

	return (
		<EmployeesFilter
			label={t('employees.filters.cycles.label')}
			name="cycleTemplateIDs"
			options={[
				..._.sortBy(
					query.data?.cycleTemplates.edges.map(({ node }) => ({
						label: localize(node.title).text,
						value: `cycleTemplateIDs:${node.id}`,
					})) ?? [],
					'label',
				),
				{
					label: t('employees.filters.cycles.without'),
					value: 'cycles:0',
				},
			]}
		/>
	);
}
